import { Badge } from '@frontend/design_system'
import {
  isMigratedUserSelector,
  isOperatorSelector,
} from 'redux/login/selectors'
import { useAppSelector } from 'redux/hooks'
import styles from './styles.module.scss'
import { MIGRATED_USER_BADGE } from 'texts/uiTexts'

export const MigratedUserBadge = ({
  errors,
}: {
  errors: Record<string, string>
}) => {
  const isMigratedUser = useAppSelector(isMigratedUserSelector)
  const isOperator = useAppSelector(isOperatorSelector)
  const isMigratedUserFlow = isMigratedUser && !isOperator

  if (
    !isMigratedUserFlow ||
    Object.values(errors).filter(Boolean).length === 0
  ) {
    return null
  }

  return (
    <Badge
      color="yellow800"
      typographyName="body1WMedium"
      type="warning"
      className={styles.badge}
      message={MIGRATED_USER_BADGE}
    />
  )
}
